module.exports = __webpack_public_path__ + "img/filter.404eef3c.jpg";